/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Private_HintInputs */



/**
* | output |
* | --- |
* | "Only organizers see a private decklist, until the event ends. The winner's is always published." |
*
* @param {Deck_Private_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_private_hint = /** @type {((inputs?: Deck_Private_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Private_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les organisateurs voient une decklist privée, jusqu'à la fin du tournoi. Celle du vainqueur est toujours publiée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los organizadores ven una decklist privada, hasta que acaba el torneo. La del ganador siempre se publica.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Só os organizadores veem uma decklist privada, até o fim do torneio. A do vencedor é sempre publicada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli organizzatori vedono una decklist privata, fino alla fine del torneo. Quella del vincitore è sempre pubblicata.")
	return /** @type {LocalizedString} */ ("Only organizers see a private decklist, until the event ends. The winner's is always published.")
});